import { INIT_PAGE_STATE } from "../../constant/constant";
import {
  OAUTH_KEY_GET_LIST,
  OAUTH_KEY_GET_LIST_SUCCESS,
  OAUTH_KEY_GET_LIST_ERROR,
  OAUTH_KEY_ADD_EDIT,
  OAUTH_KEY_SAVE_ADD_EDIT,
  OAUTH_KEY_SAVE_ADD_EDIT_SUCCESS,
  OAUTH_KEY_SAVE_ADD_EDIT_ERROR,
  OAUTH_KEY_DELETE,
  OAUTH_KEY_DELETE_SUCCESS,
  OAUTH_KEY_DELETE_ERROR,
} from "./actions";

const INIT_STATE = {
  list: {
    data: null,
    loading: false,
    error: false,
    filter: null,
    page: INIT_PAGE_STATE,
    appName: null,
    dateFrom: null,
    dateTo: null,
  },
  addEdit: {
    data: null,
    mode: "add",
    loading: false,
    error: false,
    message: null,
  },
  deleting: {
    data: null,
    loading: false,
    error: false,
    message: null,
    confirmed: false,
  },
};

const oauthKeyReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case OAUTH_KEY_GET_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          appName: action.payload.appName,
          dateFrom: action.payload.dateFrom,
          dateTo: action.payload.dateTo,
        },
      };

    case OAUTH_KEY_GET_LIST_SUCCESS: {
      const { data, total, page, limit, totalPages } = action.payload;
      return {
        ...state,
        list: {
          ...state.list,
          data: data || [],
          page: {
            ...state.list.page,
            currentPage: page,
            selectedPageSize: limit,
            totalItem: total,
            totalPage: totalPages,
            itemCount: (data || []).length,
          },
          loading: false,
          error: false,
          message: null,
        },
      };
    }

    case OAUTH_KEY_GET_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          data: null,
          loading: false,
          error: true,
          page: INIT_PAGE_STATE,
          message: action.payload,
        },
      };

    case OAUTH_KEY_ADD_EDIT:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          data: action.payload.item,
          mode: action.payload.mode,
          loading: false,
          error: false,
          message: null,
        },
      };

    case OAUTH_KEY_SAVE_ADD_EDIT:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          data: action.payload.item,
          loading: true,
          error: false,
          message: null,
        },
      };

    case OAUTH_KEY_SAVE_ADD_EDIT_SUCCESS:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          data: null,
          loading: false,
          error: false,
        },
      };

    case OAUTH_KEY_SAVE_ADD_EDIT_ERROR:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          loading: false,
          error: true,
          message: action.payload?.toString?.() || String(action.payload),
        },
      };

    case OAUTH_KEY_DELETE:
      return {
        ...state,
        deleting: {
          ...state.deleting,
          data: action.payload.item,
          confirmed: action.payload.confirmed,
          loading: !!action.payload.confirmed,
          error: false,
          message: null,
        },
      };

    case OAUTH_KEY_DELETE_SUCCESS:
      return {
        ...state,
        deleting: {
          ...state.deleting,
          data: null,
          loading: false,
          error: false,
          message: null,
          confirmed: false,
        },
      };

    case OAUTH_KEY_DELETE_ERROR:
      return {
        ...state,
        deleting: {
          ...state.deleting,
          loading: false,
          error: true,
          message: action.payload,
          confirmed: false,
        },
      };

    default:
      return state;
  }
};

export default oauthKeyReducer;
